import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { DialogHost } from '@core/dialog/dialog-host/dialog-host';
import { ToastHost } from '@core/notification/toast-host/toast-host';

/**
 * Root host: the routed outlet plus the two global overlay hosts. Chrome belongs to Shell,
 * which is itself a route.
 *
 * Stacking is settled by z-index, not document order - `#toasts` is 200 and dialog scrims
 * start at 1000 - so the template order here is only for readability.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DialogHost, ToastHost],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {}
